import { render, staticRenderFns } from "./task-allocation-foreground-director.vue?vue&type=template&id=01028144&scoped=true&"
import script from "./task-allocation-foreground-director.vue?vue&type=script&lang=js&"
export * from "./task-allocation-foreground-director.vue?vue&type=script&lang=js&"
import style0 from "./task-allocation-foreground-director.vue?vue&type=style&index=0&id=01028144&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01028144",
  null
  
)

export default component.exports